import React, {useState, useEffect} from "react";
import {connect} from "react-redux";
import {withRouter} from "../../../helpers/withRouter";
import T from "../../../shared/component/t/T";
import {default as _} from '../../../helpers/Translate';
import ComboBox from "../../../shared/component/ComboBox/ComboBox2";
import Storage from "../../../helpers/Storage"

function ReportCP_ChooseReports(props) {
    const [direction] = useState(Storage.directionGet())
    const [language] = useState(props.language)

    const [reportOptions, setReportOptions] = useState(props?.reportOptions)
    const [reportOptionSelected, setReportOptionSelected] = useState(props.reportOptionSelected)

    const [showImages, setShowImages] = useState(false)
    const [images, setImages] = useState(props.images)
    const [imagesOptions, setImagesOptions] = useState(props?.imageOptions)
    const [imagesOptionSelected, setImagesOptionSelected] = useState(-1)
    const [imageHoveredDiv, setImagesHoveredDiv] = useState()

    useEffect(()=>{
        setImages(props.images)
        setImagesOptionSelected(props.report?.series_id === null ? -1 : props.report?.series_id)
        setImagesOptions(initImageOptions(props.study?.series))
    },[props.study, props.images, props.report])

    useEffect(()=>{
        setReportOptions(props?.reportOptions)
    },[props?.reportOptions])
    useEffect(()=>{
        setReportOptionSelected(props?.reportOptionSelected)
    },[props?.reportOptionSelected])

    const imagesInfoOver = () => {
        let series = imagesOptionSelected
        if (series && series !== -1) {
            setShowImages(true)
            let img = images.filter(item => item.imgSeries === `${series}`)
            if (img) {
                let divImages = []
                for (let i = 0; i < Math.min(img.length, 9); i++) {
                    divImages.push(<img key={i} alt="" loading="lazy" src={`${img[i].imgSeriesFileLink}?width=100`} />);
                }
                setImagesHoveredDiv(divImages)
            }
        }
    }

    const imagesInfoOverOut = () => {
        setShowImages(false)
    }

    const handleChangeSelectedReport = (value) => {
        setReportOptionSelected(value)
        props?.reportChanges(value)
    }

    const handleChangeSelectedImage = (value) => {
        value = value.toString() === "-1" ? null : parseInt(value)
        setImagesOptionSelected(value)
        props.handleChangeSelectedImage(value)
    }

    const initImageOptions = (img) => {
        let chooseOne = { id: -1, text: "choose_one", value: -1 }
        let t = [chooseOne]

        Object.entries(img).map(([key, value]) => {
            let option = { id: parseInt(key),
                text: `(${value.file_count}) ${value.description}`,
                value: key }
            t = [...t, option]
        });
        return t
    }

    return (
        <>
            <div className='ReportSeries'>
                <span className='__title'> <T token={"choose_report"} />:</span>
                <ComboBox comboboxValues={reportOptions}
                          nonTransparent
                          changeValueHandler={handleChangeSelectedReport}
                          selectedItem={reportOptionSelected}
                />
            </div>
            {(reportOptionSelected !== "-1") &&
                <div className='PicsSeries'>
                    <span className='__title'><T token={"pics_series"} />:</span>
                    <ComboBox comboboxValues={imagesOptions}
                              nonTransparent
                              changeValueHandler={handleChangeSelectedImage}
                              selectedItem={imagesOptionSelected}
                    />
                    <i className={'fal fa-circle fa-circle-info'}
                       onMouseOver={imagesInfoOver}
                       onClick={imagesInfoOver}
                       onMouseOut={imagesInfoOverOut}
                       title={_.init("images_info_tooltip", language)}
                    >
                        {showImages &&
                            <div className={`imagesHover ${direction}`}>
                                {imageHoveredDiv}
                            </div>
                        }
                    </i>
                </div>
            }
        </>
    )
}

const mapStateToProps = state => {
    const language = state.LangReducer.language;
    return {language};
};

export default connect(mapStateToProps)(withRouter(ReportCP_ChooseReports));